import React from 'react';
import { handleChange } from 'lib/stores/formStore';
import withValidations from 'lib/hocs/withValidations';
import { formatIdFromName } from 'lib/utility';

import FormLabel from './FormLabel';

const FormNumber = ({ name, label, id, value, inputClass, required }) => {
  const handleInput = e => {
    const targetValue = e.target.value.replace(/[^0-9.]+/g, '');

    handleChange(targetValue, e.target.name);
  };

  return (
    <div className="mb-3">
      <FormLabel id={id || formatIdFromName(name)} label={label || name} required={required} />
      <input
        name={name}
        type="text"
        value={value}
        onChange={handleInput}
        id={id || formatIdFromName(name)}
        data-testid={id || formatIdFromName(name)}
        required={required}
        className={inputClass}
      />
    </div>
  );
};

export default withValidations({ required: false })(FormNumber);
